import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import {
  GetAudienceDocument,
  type GetAudienceQuery,
} from '../../../../../../graphql/query/audiences/GetAudience.generated.tsx';

type UseAudienceDetails = {
  data?: GetAudienceQuery['audience_by_pk'];
  loading: boolean;
  error?: Error;
};

export const useAudienceDetails = (id: string): UseAudienceDetails => {
  const { data, error, loading } = useQuery(GetAudienceDocument, { variables: { id } });

  return useMemo(() => {
    if (loading) {
      return { data: undefined, loading, error: undefined };
    }

    if (error) {
      return { data: undefined, loading, error };
    }

    return { data: data?.audience_by_pk, loading, error };
  }, [data?.audience_by_pk, error, loading]);
};
